import { computed, Directive, input } from '@angular/core';
import { hlm } from '@spartan-ng/helm/utils';
import type { ClassValue } from 'clsx';

@Directive({
  selector: '[hlmInputGroup],hlm-input-group',
  host: {
    'data-slot': 'input-group',
    role: 'group',
    '[class]': '_computedClass()',
  },
})
export class HlmInputGroup {
  public readonly userClass = input<ClassValue>('', { alias: 'class' });

  protected readonly _computedClass = computed(() =>
    hlm(
      'group/input-group dark:bg-input/30 relative flex w-full h-[44px] items-center rounded-md border transition-color border-stroke-neutral-medium',
      'min-w-0 has-[>textarea]:h-auto',
      '[&>input]:outline-none hover:bg-components-background-neutral-lighter hover:[&>input]:bg-components-background-neutral-lighter',
      // Variants based on alignment.
      'has-[>[data-align=inline-start]]:[&>input]:pl-2',
      'has-[>[data-align=inline-end]]:[&>input]:pr-2',
      'has-[>[data-align=block-start]]:h-auto has-[>[data-align=block-start]]:flex-col has-[>[data-align=block-start]]:[&>input]:pb-3',
      'has-[>[data-align=block-end]]:h-auto has-[>[data-align=block-end]]:flex-col has-[>[data-align=block-end]]:[&>input]:pt-3',
      // Focus state.
      'has-[[data-slot=input-group-control]:focus-visible]:border-ring has-[[data-slot=input-group-control]:focus-visible]:ring-ring/50 has-[[data-slot=input-group-control]:focus-visible]:outline-feedback-informative-main has-[[data-slot=input-group-control]:focus-visible]:outline-2 has-[[data-slot=input-group-control]:focus-visible]:outline-offset-2',
      // Error state.
      'has-[[data-slot=input-group-control]:invalid]:border-feedback-negative-main',

      this.userClass(),
    ),
  );
}
